// extracted by mini-css-extract-plugin
module.exports = {"ArithmeticCodec":"BinaryAdaptiveArithmetic_ArithmeticCodec__1QRvR","ArithmeticAlgorithm":"BinaryAdaptiveArithmetic_ArithmeticAlgorithm__1E8nz"};